import {Raycasting, RouteOrbitControls} from "./Controls";
import {useContext, useEffect, useRef} from "react";
import TopDownButton from "../overlay/TopDownButton";
import {RouteFocusState, TopDownState} from "../canvas/CanvasState";
import RouteInfoPanel from "../overlay/RouteInfoPanel";
import {WallContext} from "../../contexts/WallContext";
import {SetCanvasStateContext} from "../../contexts/CanvasContext";
import * as THREE from "three";
import OutlineType from "../canvas/OutlineType";
import {AppContext} from "../../AppContext";

export default function RouteFocusController({canvas, setSceneState, canvasState}) {
    const route = canvasState.route;
    const wall = useContext(WallContext);
    const setCanvasState = useContext(SetCanvasStateContext);

    function onBackToTopView() {
        setSceneState(new TopDownState(route.getCenter()));
    }


    useEffect(() => {
        if (wall === null || canvas === null)
            return;

        function onControlsUpdate() {
            canvas.render();
        }

        const routeMeshes = route.holds.map(hold => hold.holdMesh);

        function onRouteHover(raycastEvent) {
            const result = raycastEvent.result;
            if (result.hit) {
                if (AppContext.Mutable.isCanvasDragging)
                    return;
                const hitRoute = result.target.object;
                canvas.setOutlinedObjects(
                    OutlineType.HIGHLIGHT,
                    [...new Set([...hitRoute.holds.map(hold => hold.holdMesh), ...routeMeshes])]
                );
            } else {
                canvas.setOutlinedObjects(OutlineType.HIGHLIGHT, routeMeshes);
            }
            canvas.render();
        }

        function onRouteClick(raycastEvent) {
            const result = raycastEvent.result;
            console.assert(result.hit);
            const route = result.target.object;
            setCanvasState(new RouteFocusState(route));
        }

        function onRouteApproach(raycastEvent) {
            onRouteHover(raycastEvent)
        }

        function onRouteApproximateClick(raycastEvent) {
            onRouteClick(raycastEvent);
        }

        const controls = new RouteOrbitControls(canvas.getCanvasElement(), canvas.camera, canvas.cameraAnimation);
        controls.addEventListener("change", onControlsUpdate);
        controls.register(route, wall.wallMesh);

        const raycasting = new Raycasting(canvas.getCanvasElement(), canvas.camera, true);
        raycasting.addEventListener("object_hover", onRouteHover);
        raycasting.addEventListener("object_approach", onRouteApproach);
        raycasting.addEventListener("object_click", onRouteClick);
        raycasting.addEventListener("object_approach_click", onRouteApproximateClick);
        for (let i = 0; i < wall.routes.length; i++) {
            const otherRoute = wall.routes[i];
            if (otherRoute === route)
                continue;
            raycasting.addTarget(otherRoute, otherRoute.holds.map(hold => hold.holdMesh));
            raycasting.addApproachTarget(otherRoute, otherRoute.holds.map(hold => new THREE.Sphere(hold.getCenter(), 0.5)));
        }
        raycasting.register();

        canvas.setOutlinedObjects(OutlineType.HIGHLIGHT, routeMeshes);
        return () => {
            raycasting.cancelAllListeners();
            raycasting.unregister();

            controls.cancelAllListeners();
            controls.unregister();
        }
    }, [wall, route, canvas, setCanvasState]);
    useEffect(() => {
        canvas.render();
    });

    return (<>
        <TopDownButton onClick={onBackToTopView}/>
        <RouteInfoPanel route={route} onClickBack={onBackToTopView}/>
    </>);
}